import { ComponentProps, DispatchWithoutAction, FC } from 'react';
import { Modal } from '../shared/modal/Modal';
import { Anchor, AnchorModel, HStack, Link, Text, VStack } from '@bpba/ui-components';
import {
  MORA_INFO_1,
  MORA_INFO_2_DESKTOP,
  MORA_INFO_2_MOBILE,
  MORA_PHONE,
  MORA_PHONE_TITLE,
  MORA_PHONE_URL,
  MORA_TITULO_MODAL,
} from '../../constants/data';
import { ErrorIcon } from '../shared/ErrorIcon';
import { width, WidthProps } from 'styled-system';
import styled from 'styled-components';
import { CancelButton } from '../shared/modal/CancelButton';
import { ConfirmButton } from '../shared/modal/ConfirmButton';
import { ReactComponent as TelephoneSVG } from '../../assets/icons/telephone.svg';

const ERROR_ICON_SIZE = [28, 48];

const phoneLink = new AnchorModel(0, undefined, new Link(MORA_PHONE_URL, false, false, undefined));

type Props = {
  show: boolean;
  close?: DispatchWithoutAction;
};

export const MoraDialog: FC<Props> = ({ show, close }) => {
  return (
    <Modal
      show={show}
      title={MORA_TITULO_MODAL}
      showConfirmButton={false}
      showCancelButton={false}
      showErrorMessage={false}
      onCancel={close}
    >
      <HStack justifyContent="center" alignItems="center" marginTop={[23, 45]} marginBottom={[33, 39]}>
        <ErrorIcon size={ERROR_ICON_SIZE} marginRight={['12px', '31px']} tabIndex={-1} />
        <StyledText width={[192, 354]} fontSize={14} lineHeight={'16pt'} tabIndex={0}>
          {MORA_INFO_1}
        </StyledText>
      </HStack>

      {/*Parte inferior versión mobile*/}
      <VStack display={['flex', 'none']} alignItems="center">
        <Text
          color="primary.0"
          marginBottom="20px !important"
          fontSize={14}
          fontWeight="700"
          lineHeight="16pt"
          dangerouslySetInnerHTML={{ __html: MORA_INFO_2_MOBILE }}
          tabIndex={0}
        />

        <Anchor data={phoneLink} marginBottom={11} tabIndex={-1}>
          <ConfirmButton show={true} enable={true} label={MORA_PHONE_TITLE}>
            <HStack alignItems="center">
              <TelephoneSVG height={14} />
              {MORA_PHONE}
            </HStack>
          </ConfirmButton>
        </Anchor>

        <CancelButton show={true} onClickCallback={close} label="Cerrar" backgroundColor="transparent" />
      </VStack>

      {/*Parte inferior versión desktop*/}
      <VStack display={['none', 'flex']} alignItems="center">
        <Text
          color="primary.0"
          marginBottom="39px !important"
          fontSize={14}
          fontWeight="700"
          dangerouslySetInnerHTML={{ __html: MORA_INFO_2_DESKTOP }}
          tabIndex={0}
        />

        <ConfirmButton show={true} onClickCallback={close} enable={true} label="Cerrar" />
      </VStack>
    </Modal>
  );
};

type StyledTextProps = ComponentProps<typeof Text> & WidthProps;
const StyledText = styled(Text)<StyledTextProps>(width);
